import instance from './axios-instance'

/**
 * 获取正式商品列表。
 * @param {string} keyword 搜索关键词
 * @param {number} page 页码
 * @param {string} sortProduct 排序方式
 * @returns {Promise<any>} 商品列表响应
 */
export const getAllProducts = async (
  keyword = '',
  page = 1,
  sortProduct = '',
) => {
  let queryString = `/api/v1/products?page=${page}`

  if (keyword !== '') {
    queryString += `&keyword=${keyword}`
  }

  if (sortProduct !== '') {
    queryString += `&sort=${sortProduct}`
  }

  const { data } = await instance.get(queryString)
  return data
}

/**
 * 获取正式商品详情。
 * @param {string} id 商品 ID
 * @returns {Promise<any>} 商品详情响应
 */
export const getProductById = async (id) => {
  const { data } = await instance.get(`/api/v1/products/${id}`)
  return data
}

/**
 * 创建正式商品。
 * @param {FormData} payload 商品表单数据
 * @returns {Promise<any>} 创建结果
 */
export const createProduct = async (payload) => {
  const { data } = await instance.post(`/api/v1/admin/products`, payload)
  return data
}

/**
 * 更新正式商品。
 * @param {{ id: string, payload: FormData }} options 更新参数
 * @returns {Promise<any>} 更新结果
 */
export const updateProduct = async ({ id, payload }) => {
  const { data } = await instance.put(`/api/v1/admin/products/${id}`, payload)
  return data
}

/**
 * 删除正式商品。
 * @param {string} id 商品 ID
 * @returns {Promise<any>} 删除结果
 */
export const deleteProduct = async (id) => {
  const { data } = await instance.delete(`/api/v1/admin/products/${id}`)
  return data
}

/**
 * 获取爬虫来源列表。
 * @returns {Promise<any>} 来源列表响应
 */
export const getSpiderProductSources = async () => {
  const { data } = await instance.get(`/api/v1/admin/spider-products/sources`)
  return data
}

/**
 * 获取爬虫分类列表。
 * @param {string} source 爬虫来源
 * @returns {Promise<any>} 分类列表响应
 */
export const getSpiderProductCategories = async (source = 'lcsc') => {
  const { data } = await instance.get(
    `/api/v1/admin/spider-products/categories?source=${source}`,
  )
  return data
}

/**
 * 获取爬虫商品预览列表。
 * @param {{ source?: string, keyword?: string, categoryId?: string, page?: number, limit?: number }} query 查询条件
 * @returns {Promise<any>} 预览列表响应
 */
export const getSpiderProducts = async (query = {}) => {
  const params = new URLSearchParams()
  const source = query.source || 'lcsc'
  const page = query.page || 1
  const limit = query.limit || 20

  params.set('source', source)
  params.set('page', page)
  params.set('limit', limit)

  if (query.keyword) {
    params.set('keyword', query.keyword)
  }

  if (query.categoryId) {
    params.set('categoryId', query.categoryId)
  }

  const { data } = await instance.get(
    `/api/v1/admin/spider-products?${params.toString()}`,
  )
  return data
}

/**
 * 批量导入爬虫商品为正式商品。
 * @param {{ source?: string, productCodes: string[], imageImportMode?: 'local' | 'remote' }} payload 导入参数
 * @returns {Promise<any>} 导入结果
 */
export const importSpiderProducts = async (payload) => {
  const { data } = await instance.post(
    `/api/v1/admin/spider-products/import`,
    payload,
  )
  return data
}
